module.exports = __webpack_public_path__ + "static/media/user-friends.f21aeaa4.svg";